import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from "../../labels/interviewProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import ReportTypes from "../../labels/reportTypes.json"
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getSubjectlistByExamId
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";

import { SET_PRESENT_ABSENT_COUNTS } from "../../../common/constants/ActionTypes";
import {
  getGeneralSlabReport
} from "../../actions/interviewProcessActions";
import { getYearList, getAdvertisementlistByYear } from "../../../common/actions/commonActions";
import DevideTableColumn from "./devideTableColumn";

const GeneralSlabReport = () => {

  const pdfRef = useRef(null);

  const { register, handleSubmit, errors, reset } = useForm(
    {
      mode: "onChange",
    }
  );


  let { advertisementList, examList, subjectList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  let { generalSlabReportData } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );
  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let { statisticalReportData } = useSelector(
    (state) => state.statisticalReducer,
    shallowEqual
  );

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [confirmClicked, setConfirmClicked] = useState(true);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [pdfPrintDisabled, setPdfPrintDiabled] = useState(false);
  const [chunkData, setChunkData] = useState([]);
  const [reportId, setReportId] = useState('')
  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();

  useEffect(() => {

    dispatch(getYearList());
    window.scrollTo(0, 0)
    dispatch({
      payload: {},
      type: SET_PRESENT_ABSENT_COUNTS
    })
    setReloadItem(!reloadItem);
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const chunkedData = [];
    const recordsPerChunk = 36;
    if (generalSlabReportData?.slab?.length > 0) {
      for (let i = 0; i < generalSlabReportData.slab.length; i += recordsPerChunk) {
        chunkedData.push(generalSlabReportData.slab.slice(i, i + recordsPerChunk));
      }
    }
    setChunkData(chunkedData)
  }, [generalSlabReportData]);

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setReportId('')
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(true);
    setPrintFlag(true);
    examList.length = 0;
    subjectList.length = 0;
    setChunkData([]);
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    setSelectedExam(ele);
    setSaveButtonFlag(true);
    setConfirmClicked(true);
    setReportId('')
    setPrintFlag(true);
    subjectList.length = 0;
    setChunkData([]);
    // ele && dispatch(getSubjectlistByExamId(ele));
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0
    }
    if (examList) {
      examList.length = 0;
    }
    setChunkData([]);
    setSaveButtonFlag(true);

    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    // setSelectedAdvertNo("");
    // setSelectedExam("");
    // setSelectedSubject("");
    reset()
    setSaveButtonFlag(true);
    setConfirmClicked(true);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    examList.length = 0;
    subjectList.length = 0;
    generalSlabReportData.length = 0;
    setChunkData([]);
  };

  const handleReportChange = (selectedValue) => {
    setReportId(selectedValue)
    setPrintFlag(false);
    setSaveButtonFlag(false);
    setConfirmClicked(false);
    setPrintFlag(true);
    setChunkData([]);
    setReloadItem(!reloadItem);
  }

  const genPdf = () => {
    const htmlContent = document.createElement('div');
    let reportTypelabel = ReportTypes.REPORTS_DROPDOWN.find(item => item.value === reportId)

    htmlContent.innerHTML = '<div class="row d-flex flex-column align-items-center "><h5>' + commonLabels.MPSC + '</h5><h5>' + generalSlabReportData.examName + '</h5><h5>' + reportTypelabel.label + '</h5></div> <div class=" ml-5 d-flex flex-column"><br> <div><small>Column Name 1 Indicates Count of Candidates compatible for Open Post</small></div> <div><small> Column Name 2 Indicates Count of Candidates not compatible for Open Post</small></div></div>';
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [1, 0.3, 0.5, 0.3],
      filename: "GeneralSlabReport.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.2;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = generalSlabReportData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`GeneralSlabReport.pdf`);
      });
  };

  const downloadPdf = () => {
    setPdfPrintDiabled(true);
    if (pdfRef) {
      genPdf();
    }
    setReloadItem(!reloadItem);
  };

  const onSubmit = () => {

    dispatch(getGeneralSlabReport(selectedExam, reportId));
    setPrintFlag(false);
    setReloadItem(!reloadItem);
  };

  return (
    <div className="commonContentArea">
      <h5> {label.General_Slab_Report} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>

                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className='form-group col-md-3'>
                  <label className="float-left">
                    {commonLabels.ReportsType}
                    <span className="redColor">*</span>
                  </label>
                  <select className="form-control"
                    name="selected_report"
                    value={reportId}
                    onInput={(e) => { handleReportChange(e.target.value) }}
                    ref={register({ required: true })}
                  >
                    <option key="" value="">{commonLabels.COMBO_SELECT}</option>
                    {ReportTypes && ReportTypes.REPORTS_DROPDOWN && ReportTypes.REPORTS_DROPDOWN.length > 0 && ReportTypes.REPORTS_DROPDOWN.map((ele, i) => {
                      return <option key={i} value={ele.value}>{ele.label}</option>
                    })}
                  </select>
                  {_.get("selected_report.type", errors) === "required" && (
                    <p className="errorText">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                </div>

              </div>

              <div className="row">
                <div className="form-group col-md-8">
                  <>     <button
                    type="reset"
                    className="btn btn-secondary mr-2"
                    onClick={() => onCancelButton()}
                  >
                    {commonLabels.BUTTON_CANCEL}
                  </button>

                    <button
                      type="submit"
                      className="btn btn-primary mr-2"
                      disabled={saveButtonFlag}
                      onClick={handleSubmit((e) => {
                        onSubmit(e);
                        setConfirmClicked(true);
                      })}
                    >
                      {commonLabels.BUTTON_VIEW}
                    </button>
                  </>
                  <button
                    type="button"
                    className="btn btn-primary mr-2"
                    disabled={(printFlag) || (!generalSlabReportData.slab)}
                    onClick={() => {
                      downloadPdf();
                    }}

                  >
                    {commonLabels.BUTTON_PRINT}
                  </button>

                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {reportId && chunkData && chunkData?.length > 0 && (
        <div ref={pdfRef} >
          {
            chunkData.map((chunk, index) => (
              <DevideTableColumn key={index} chunkData={chunk} />
            ))

          }
        </div>
      )}
    </div>
  );
};

export default GeneralSlabReport;
